// src/components/CustomButton.jsx
import React from "react";
import "./CustomButton.css";

const CustomButton = ({
  onClick,
  title,
  children,
  icon: Icon,
  iconProps = {},
  className = "",
  type = "default",
  ...restProps
}) => {
  return (
    <button
      className={`custom-btn custom-btn-${type} ${className}`}
      onClick={onClick}
      title={title}
      type="button"
      {...restProps}
    >
      <div className="d-flex align-items-center justify-content-center">
        {Icon && <Icon fontSize="small" className="btn-icon" {...iconProps} />}
        <span className="btn-text">{children}</span>
      </div>
    </button>
  );
};

export default CustomButton; // ONLY THIS LINE
